import { computed, makeObservable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';

import { ServiceEntriesDataStore } from './service-entries-data.store';

@injectable()
export class ServiceEntriesViewStore {
    constructor(
        @inject(ServiceEntriesDataStore)
        private readonly serviceEntriesDataStore: ServiceEntriesDataStore
    ) {
        makeObservable(this);
    }

    @computed get serviceEntries() {
        return this.serviceEntriesDataStore.serviceEntries.map(serviceEntry => {
            const count = (serviceEntry.serviceTypes?.length ?? 0) - 1; // -1 to exclude the first service record

            return {
                id: serviceEntry.id,
                vehicleName: serviceEntry.vehicleName ?? '',
                firstServiceType: serviceEntry.serviceTypes[0] ?? '',
                numberOfServiceRecords: count > 0 ? `+${count.toString()}` : '',
                serviceDate: this.formatDate(serviceEntry.serviceDate),
            };
        });
    }

    private formatDate(date: Date) {
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    }
}
